export const formatTimeScaleLabel = "q9nPKb";
export const formatTimeScaleWithDescriptionLabel = "Y7tC8c";
export const leastSpaceTimeScaleOptionDescription = "bPSWfe";
export const mostSpaceTimeScaleOptionDescription = "DOgEfe";
export default {formatTimeScaleLabel,formatTimeScaleWithDescriptionLabel,leastSpaceTimeScaleOptionDescription,mostSpaceTimeScaleOptionDescription};